import {Box, Rating} from "@mui/material";
import RestoreIcon from '@mui/icons-material/Restore';
import React, {useEffect, useState} from "react";
import {useTheme} from "../../../contexts/theme";
import StyledIconButton from "../StyledIconButton/StyledIconButton";
import {updateClip} from "../../../queries/clipQueries";

export interface CustomRatingProps {
    auto_rating: number;
    manual_rating?: number | null;
    clipId: string;
    onChangeCustomRating?: (value: boolean) => void;
}

const CustomRating = ({auto_rating, manual_rating, clipId, onChangeCustomRating} : CustomRatingProps) => {
    const theme = useTheme();
    const [tempManualRating, setTempManualRating] = useState<number | null>(null);
    const [tempAutoRating, setTempAutoRating] = useState<number>(0);

    // reset local state every time the clip ID changes
    useEffect(() => {
        setTempManualRating(manual_rating ?? null);
        setTempAutoRating(auto_rating);
    }, [clipId, manual_rating, auto_rating]);

    useEffect(() => {
        setTempAutoRating(auto_rating);
    }, [auto_rating]);

    useEffect(() => {
        if(manual_rating !== undefined) {
            setTempManualRating(manual_rating);
        }
    }, [manual_rating]);

    const handleResetRatingValue = async () => {
        try {
            if(onChangeCustomRating) {
                onChangeCustomRating(true)
            }
            await updateClip(clipId, -1);
            setTempManualRating(null);
        } catch (error) {
            console.error("Error during rating reset. ")
        } finally {
            if(onChangeCustomRating) {
                onChangeCustomRating(false)
            }
        }
    }

    async function updateRatingValue(ratingValue: number | null) {
        try {
            if (onChangeCustomRating) {
                onChangeCustomRating(true)
            }
            await updateClip(clipId, ratingValue);
            setTempManualRating(ratingValue);
        } catch (e) {
            console.error("Error during rating update. ")
        } finally {
            if(onChangeCustomRating) {
                onChangeCustomRating(false)
            }
        }

    }

    return (
        <Box display={'flex'} alignItems={'center'} height={'24px'}>
            <Rating
                name="read-only"
                value={tempManualRating ?? tempAutoRating}
                precision={0.5}
                sx={{ fontSize: '15px', "& .MuiRating-iconEmpty": { color: theme.palette.blue }, marginRight: theme.spacing.xs }}
                onChange={(event, newValue) => {
                    if (newValue) updateRatingValue(newValue)
                }}
            />
            {tempManualRating !== null && (
                <StyledIconButton onClick={handleResetRatingValue} width={'5px'} height={'5px'}>
                    <RestoreIcon sx={{ fontSize: 15 }} />
                </StyledIconButton>
            )}
        </Box>
    );
}

export default CustomRating;